import { type MetaFunction } from '@remix-run/node'
import productAuto from './product-auto.png'

export const meta: MetaFunction = () => [
	{ title: 'Auto Insurance' },
	{
		name: 'description',
		content: 'We offer Auto Insurance.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="mt-2 text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-4xl">
				Auto Insurance
			</h1>
			<img
				src={productAuto}
				alt="A car driving down a road."
				className="rounded-lg object-cover object-center"
			/>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				There are three major categories of coverage on a personal automobile
				insurance policy.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				1. You and Your Family
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				In New York, the primary medical coverage for you and your family - all
				of the passengers in your car - is called Personal Injury Protection
				(PIP). It's common to hear this coverage referred to as no-fault
				coverage because it applies regardless of whether the accident was
				caused by the driver of your vehicle or the driver of another vehicle.
				The benefit to this is that you have control over the amount of
				coverage, within limits. NY State law requires a minimum of $50,000
				coverage, and insurers tend to offer the option to buy additional
				personal injury protection.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Within the PIP coverage family, we also find an optional coverage called
				“basic economic loss.” Your policy may abbreviate this with the acronym
				OBEL. It provides an additional $25,000 available with more flexibility
				to how the coverage can be applied. For instance, it can be used to
				offset the cost of physical therapy or assist in compensating for lost
				wages following an injury in a motor vehicle accident.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				In some instances the behavior of the vehicle operator can cause the PIP
				coverage to be voided. One example is driving under the influence of
				alcohol. For those individuals that suffer an injury when the driver has
				been drinking, there may still be hope for some coverage to apply if the
				policy contains a line item called Medical Payments. While Medical
				Payments can be used in a similar manner to how the PIP coverage takes
				care of ambulance, doctor, and hospital bills, it may be the only option
				remaining in some circumstances.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Beyond the bills and expenses that are generated when you and your
				family are in an accident, there may also be a financial impact in the
				form of lost ability to work. A manual laborer that is paralyzed as a
				result of a hit and run accident loses the ability to work and enjoy
				many of the pleasures of life. There is a huge need for protection
				against the long-term pain and suffering that results from the
				hard-to-measure impact of an accident, particularly since there are
				drivers on the road with inadequate liability coverage and insufficient
				assets to fairly compensate you following a serious accident. Enter
				uninsured and underinsured motorist coverage. It fills the gap that is
				created when a driver operates a vehicle without any insurance or with
				an insurance policy that has too low a protection amount.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The limit of insurance that is available cannot exceed the dollar value
				of the coverage that is carried for bodily injury liability. For
				example, you cannot have a $100,000 per person limit for liability to
				others, and then $250,000 coverage for yourself.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				2. Your Vehicle
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The first optional coverage for your vehicle is called Collision. It
				helps pay for the cost of repairs to your vehicle following a motor
				vehicle accident that is deemed to be your fault. It also applies if
				your car is hit in an accident when the other driver cannot be
				identified or does not have insurance.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The second optional coverage for your vehicle has two names. Some refer
				to it simply as “other than collision.” It's more popular to hear it
				called by the name Comprehensive. It provides some coverage for many of
				the unavoidable claims that arise from the damage caused to your vehicle
				by something other than a collision. For example, Comprehensive coverage
				is designed to protect you from a huge out-of-pocket expense from
				repairs made to your car following a deer or other animal that hits your
				car. Occasionally we hear stories of a car that has a mechanical or
				electrical problem that results in a fire - Comprehension coverage can
				cover that, as well. Despite your best efforts to secure your vehicle,
				it may some day be stolen. A heavy windstorm could cause a tree to fall
				upon your car. Another frequent occurrence that triggers Comprehensive
				coverage to come into play is damage to the window glass. Many find it
				valuable to select a $0 deductible for glass damage. This is also known
				as “Full Glass" coverage.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				An accident or disablement can cause more financial loss to you than
				just the repair bill. Fixing your car can take a while. While your
				repair facility is doing the repairs, you may be without a mode of
				transportation. It may be possible to rent a substitute vehicle so you
				do not lose mobility. Your insurance policy may have an option to add
				rental car reimbursement coverage. If selected, your insurer will assist
				with all or part of the cost of a rental car. We typically see a limit
				of 30 days for this coverage on a policy, and fortunately this time
				frame is sufficient in almost all cases. From time to time we do see
				situations involving a repair facility with just the wrong series of
				events that leads to delays that push the limits of coverage.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Whether caused by an accident or not, you may encounter the need for a
				roadside rescue. It may be labor such as help with changing flat tire,
				or engine trouble may necessitate a tow to a repair garage. While the
				cost of these events is relatively small, some insurance policies offer
				a coverage option that helps with the cost of towing and labor or
				roadside help. This type of coverage may already be included from the
				manufacturer of your vehicle or you may already have it through a motor
				club such as AAA.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				3. Other Drivers
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Bodily Injury and Property Damage Liability
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The process of setting up a new automobile insurance policy has several
				steps. They don't always happen in the same order, and not all steps are
				required with every policy. This list will help you know what to expect
				so you don't have any surprises.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				• The insurer may conduct a telephone verification of the information
				provided when the policy was processed.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				• Some vehicles may need to undergo a photo inspection.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				At the moment when your face hits the airbag, you don't want to be
				saying to yourself: “Did I really buy the cheapest insurance policy I
				could find?”
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Cost is important - you obviously need to be able to afford the policy
				premiums. It's important to strike the right balance of protection and
				price, maximizing the value you derive from your insurance program. Many
				people come to me and say that they have been driving for many years and
				have never been in a catastrophic accident, so they feel that they want
				to keep their policy simple. This can be a reckless behavior and denial
				of the fact that you can't predict the future. A driver can do his or
				her best to be as safe as possible on the road, and still - something
				unexpected can turn a flawless driving record inside out.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				NY State personal auto policies contain a provision that extends
				coverage from your personal car insurance policy to a car that you rent.
				There may be limitations in your policy, but it typically will cover
				these three major categories of claims that you might encounter:
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				1. damage to the rental car
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				2. damage caused by the rental car
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				3. the loss of the use of the rental car.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The coverage part that is responsible for providing the limitation of
				coverage is called Property Damage Liability. Double check your policy
				to make sure that you carry a high enough limit of liability.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Specialty vehicles- antiques and exotics
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Can't I let anybody drive my car?
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Why do I need to list my newly licensed child as a driver on my policy?
				(Undisclosed operators)
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				A word on young drivers
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				How is the cost determined?
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				* credit
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				* driving history
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				* age
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Auto insurance discount - telematics and usage based insurance
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Taking advantage of discounts,
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				* Payment option discounts
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Most policies have the option to spread premium payments over the course
				of a policy's lifetime. You should take note that the convenience of
				having the ability to spread a large premium over the course of several
				payments does have a cost. Companies charge a service fee each time a
				bill is sent. This charge is called an installment fee, and typically
				costs between $3.50 and $12.00 per bill. Those who choose to pay the
				premium for a policy all at once have the convenience of knowing that
				the premium is paid and installment fees have been avoided. An added
				benefit available from some insurers is a pay-in-full discount. This
				means that in addition to avoiding the installment fees, the actual
				premium itself is discounted below the pay-in-installments premium.
			</p>
			f
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Since policyholders must pay premiums, it makes sense to automate the
				payment process. The banking industry has enabled ways for banks to
				communicate quickly and efficiently in the transfer of money in a
				transaction. Many insurers have taken advantage of the benefits of
				payment automation by offering an automatic payment option. This means
				that the insurer will communicate with your bank so that the premium
				payments are made directly from the policyholder's checking account.
				This is often called Electronic Funds Transfer or EFT. Some companies
				also offer the alternative of having a recurring automatic credit card
				transaction. Enrollment in these payment plans has several advantages.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				    1. Installment fees may be reduced or eliminated completely.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				2. The premium you pay for the policy may be reduced if there is an EFT
				discount.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				{' '}
				3. You can be more comfortable about the premium payments knowing that
				they will never be late or missed, so the policy cannot lapse as long as
				the payments are successfully drawn from the payment account. Late fees
				can be $25 or higher.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				{' '}
				4. Continuous on-time payments can earn or regain a good-payer discount.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				See also How will my rate be determined? (Section in each chapter for
				different policy types)
			</p>
		</main>
	)
}
